import { defineStore } from 'pinia';
import { changeLanguage, locale } from '@/plugins/i18n';
import { switchLocale } from '@/api/backend/platform';
import { mapValues } from 'lodash-es';
import { Locale, getLanguageCodeFromLocale } from '@/utils/langUtils';
import store from '@/store';

export const useUIStore = defineStore('ui', {
    state: () => ({
        locale: locale.value,
    }),
    getters: {
        isLocale: (state) => mapValues(Locale, (val) => state.locale === val),
        languageCode: (state) => getLanguageCodeFromLocale(state.locale),
    },
    actions: {
        async setLocale(val: Locale) {
            if (val === this.locale) {
                return;
            }
            const response = await switchLocale(val);

            if (response.data) {
                window.location.href = response.data;
            } else {
                // change language dynamically
                await changeLanguage(val);
                this.locale = val;
                store.commit('ui/SET_LOCALE', { locale: val });
            }
        },
    },
});
